import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Legacy header-based admin client (kept for older callers). New calls should use `api` + Bearer JWT.
export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
    const jwt = typeof window !== "undefined" ? window.localStorage.getItem("lnl_admin_jwt") : null;
    if (jwt) cfg.headers["Authorization"] = `Bearer ${jwt}`;
    const legacy = typeof window !== "undefined" ? window.localStorage.getItem("lnl_admin_token") : null;
    if (legacy) cfg.headers["X-Admin-Token"] = legacy;
    return cfg;
});

export async function fetchSettings() {
    const { data } = await api.get("/settings");
    return data;
}

export async function fetchHeroSlides() {
    const { data } = await api.get("/hero-slides");
    return data;
}

export async function fetchApplicantTypes() {
    const { data } = await api.get("/applicant-types");
    return data;
}

export async function fetchDepartments() {
    const { data } = await api.get("/departments");
    return data;
}

export async function fetchPrograms(params = {}) {
    const { data } = await api.get("/programs", { params });
    return data;
}

export async function fetchProgram(slug) {
    const { data } = await api.get(`/programs/${slug}`);
    return data;
}

export async function fetchRequirements(applicantType) {
    const { data } = await api.get(`/requirements/${applicantType}`);
    return data;
}

export async function fetchNews(limit = 6) {
    const { data } = await api.get("/news", { params: { limit } });
    return data;
}

export async function fetchLeadership() {
    const { data } = await api.get("/leadership");
    return data;
}

export async function fetchStatements() {
    const { data } = await api.get("/statements");
    return data;
}

export async function fetchFaqs() {
    const { data } = await api.get("/faqs");
    return data;
}

export async function submitInquiry(payload) {
    const { data } = await api.post("/inquiries", payload);
    return data;
}

// ---- Campus Life (visitor contributions) ----
export async function fetchCampusPublic() {
    const { data } = await api.get("/campus-life/public");
    return data;
}

export async function submitCampusStory(formData) {
    // formData is a FormData instance with name, email, caption, story, consent, image, ...
    const { data } = await api.post("/campus-life/submissions", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}

export function campusImageUrl(id) {
    return `${API}/campus-life/image/${id}`;
}

export async function submitForeignInquiry(payload) {
    const { data } = await api.post("/foreign-inquiries", payload);
    return data;
}

export async function submitTuitionLead(payload) {
    const { data } = await api.post("/tuition-leads", payload);
    return data;
}

export async function submitCampusVisit(payload) {
    const { data } = await api.post("/campus-visits", payload);
    return data;
}

export async function createApplication(payload) {
    const { data } = await api.post("/applications", payload);
    return data;
}

export async function saveApplicationStep(reference, step, stepData, contactEmail) {
    const { data } = await api.patch(`/applications/${reference}`, { step, data: stepData, contact_email: contactEmail });
    return data;
}

export async function submitApplication(reference, email, consents) {
    const { data } = await api.post(`/applications/${reference}/submit`, consents, { params: { email } });
    return data;
}

export async function lookupApplication(reference, email) {
    const { data } = await api.get(`/applications/${reference}`, { params: { email } });
    return data;
}

export async function uploadDocument(reference, email, label, file) {
    const form = new FormData();
    form.append("email", email);
    form.append("label", label);
    form.append("file", file);
    const { data } = await api.post(`/applications/${reference}/documents`, form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}
